import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SdCardAlertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sd_card_alert"}/>
}
